import styled from "styled-components";

export const MessageActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionWrapper = styled.div`
  cursor: pointer;
  padding-top: 3px;
  font-size: 2rem;
  transition: color 0.3s ease;

  &:hover {
    color: var(--brand-primary);
  }
`;

export const Icon = styled.span.attrs({
    className: "rioglyph rioglyph-option-vertical",
    "data-testid": "messageActionBar"
})`
  color: var(--gray-light);
  font-size: 16px;
  cursor: pointer;

    &:hover {
        color: var(--brand-primary);
    }
    &.active {
        color: var(--brand-primary);
    }
`;

export const ListGroupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  transition: background 0.2s ease;

  &:hover {
    background: #f5f5f5;
      color: var(--brand-primary);
  }
  
  &:last-child {
      border-bottom: none;
  }
  
  .rioglyph {
    font-size: 16px;
  }
`;


